import React, { useCallback, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';
import { FiDatabase, FiPlusCircle } from 'react-icons/fi';
import Tooltip from '../Tooltip';
import { animated, useSpring } from 'react-spring';
import { MdPowerSettingsNew } from 'react-icons/md';
import { useAuth } from '../../contexts/AuthContext';

import avatarImg from '../../assets/avatar.png';

import './styles.css';

const Sidebar: React.FC = () => {
  const [hasFocus, setHasFocus] = useState<boolean[]>([]);
  const [isActive, setIsActive] = useState<boolean[]>([]);
  const [displayLogout, setDisplayLogout] = useState<boolean>(false);
  const history = useHistory();

  const { signOut } = useAuth();
  
  useEffect(() => {
    let novoArray = [...hasFocus];
    switch(history.location.pathname){
      case '/': 
        novoArray[0] = true;
      break;
      case '/gerenciar': 
        novoArray[1] = true;
      break;
      default: 
        novoArray = [true,false];
    }
    setIsActive(novoArray);
    // eslint-disable-next-line
  }, [history.location.pathname])

  const onMouseEnterLeave = useCallback((index: number, value: boolean) => {
    let novoArray = [...hasFocus];
    novoArray[index] = value;
    setHasFocus(novoArray);
    // eslint-disable-next-line
  }, []);

  const props = useSpring({
    from: { transform: 'translateY(-68px)' },
    transform: displayLogout ? 'translateY(0)' : 'translateY(-68px)',
  });

  return (
    <div className='mh-sidebar'>
      <div className='sidebar-profile'>
        <img 
          src={avatarImg} 
          alt='avatar'
          onClick={() => setDisplayLogout(!displayLogout)} 
        />
      </div>
      <div className='sidebar-logout'>
        <div className='sidebar-menu-option' onClick={signOut}>
          <MdPowerSettingsNew size={25} color='#757575' />
        </div>
      </div>
      <animated.div className='sidebar-menu' style={props}>
        <Link
          to="/"
          className='sidebar-menu-option'
          onMouseEnter={() => onMouseEnterLeave(0, true)}
          onMouseLeave={() => onMouseEnterLeave(0, false)}
        >
          <FiPlusCircle size={25} color={isActive[0] ? '#009688' : '#757575'} />
          {hasFocus[0] && <Tooltip title='Criar ambiente' />}
        </Link>
        <Link
          to="/gerenciar"
          className='sidebar-menu-option'
          onMouseEnter={() => onMouseEnterLeave(1, true)}
          onMouseLeave={() => onMouseEnterLeave(1, false)}
        >
          <FiDatabase size={25} color={isActive[1] ? '#009688' : '#757575'} />
          {hasFocus[1] && <Tooltip title='Gerenciar Bancos' />}
        </Link>
      </animated.div>
    </div>
  );
};

export default Sidebar;
